import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const {
    kollisjonskadeKjoretoyUrl,
    andreSkaderKjoretoyUrl,
    skadePaParkertKjoretoyUrl,
    kjoretoyTyveriUrl,
    rettshjelpUrl,
} = urler();

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.KollisjonskadePaKjoretoy,
        tekst: 'Kollisjon, påkjørsel eller utforkjøring',
        undertekst: 'Sammenstøt med trafikanter, personer, bygninger, gjenstander, dyr.',
    },
    {
        id: KategoriSvarId.KjoretoySkadePaParkertKjoretoy,
        tekst: 'Skade på parkert kjøretøy',
        undertekst: 'Kjøretøyet ble skadet av bulking, hærverk, takras eller annet mens det sto parkert',
    },
    {
        id: KategoriSvarId.MotorOgAndreMaskinskader,
        tekst: 'Motor og andre maskinskader',
        undertekst: 'Skade på girkasse, motor, drivverk eller elektronikk',
    },
    {
        id: KategoriSvarId.KjoretoyTyveri,
        tekst: 'Tyveri og innbrudd',
        undertekst: 'Stjålet kjøretøy eller skade i forbindelse med innbrudd ',
    },
    {
        id: KategoriSvarId.Glasskade,
        tekst: 'Glasskade',
    },
    {
        id: KategoriSvarId.Veihjelp,
        tekst: 'Veihjelp',
    },
    {
        id: KategoriSvarId.Rettshjelp,
        tekst: 'Rettshjelp',
    },
    {
        id: KategoriSvarId.AndreSkader,
        tekst: 'Andre skader',
        undertekst: 'Værrelaterte skader, feilfylling, bilnøkkel og brann',
    },
];

export const Kjoretoy = () => {
    const { url } = useConfig().links.kjoretoylandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.KollisjonskadePaKjoretoy) {
            navigate(kollisjonskadeKjoretoyUrl);
        } else if (svarId === KategoriSvarId.MotorOgAndreMaskinskader) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.MotorOgAndreMaskinSkader));
        } else if (svarId === KategoriSvarId.KjoretoySkadePaParkertKjoretoy) {
            navigate(skadePaParkertKjoretoyUrl);
        } else if (svarId === KategoriSvarId.KjoretoyTyveri) {
            navigate(kjoretoyTyveriUrl);
        } else if (svarId === KategoriSvarId.Glasskade) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Glasskade));
        } else if (svarId === KategoriSvarId.Veihjelp) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Veihjelp));
        } else if (svarId === KategoriSvarId.Rettshjelp) {
            navigate(rettshjelpUrl);
        } else if (svarId === KategoriSvarId.AndreSkader) {
            navigate(andreSkaderKjoretoyUrl);
        }
    };

    return (
        <GruppeLandingsside
            title="Kjøretøy"
            onNext={onNext}
            radioButtonsLabel="Hva gjelder det?"
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.BilSkadet}
            kategoriId="kjoretoy"
        />
    );
};
